module.exports = __webpack_public_path__ + "media/images/iconShop-d4bfaa36c0e2aabf92af4937ab496a86.png";